import api from '@/api/API';
import { AccountSubscriber } from '@/types';

export function subscribeHandler(accountId: string, userId: string): Promise<string> {
  return api
    .post(`users/${userId}/account-subscriptions`, { accountId })
    .then(response => (response as unknown as AccountSubscriber).id);
}

export function unsubscribeHandler(id: string): Promise<void> {
  return api
    .delete(`account-subscribers/${id}`)
    .then();
}
